<template>
  <div class="filter-button">
    <div class="dine-btn basic-btn" @click="openDineTypes()">
      <h6>{{ orderActive }}</h6>
      <svg class="rightarrow" fill="none">
        <use xlink:href="#right_arrow" />
      </svg>
    </div>
    <div
      class="filter-content"
      :class="{ show: openDineDropdown }"
      @mouseleave="closeDineTypes()"
    >
      <div class="content-header d-flex d-sm-none">
        <h6>{{ _T('order type') }}</h6>
        <a
          href="javascript:void(0)"
          class="close-filter"
          @click="closeDineTypes()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
              fill="#3D3F43"
            ></path>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              fill="#3D3F43"
            ></path>
          </svg>
        </a>
      </div>
      <ul>
        <li
          :class="{ active: orderType == key }"
          v-for="(orderTypeValue, key) in availableModules"
          :key="'module_' + key"
          @click=";(orderType = key), (orderActive = orderTypeValue)"
        >
          {{ orderTypeValue }}
        </li>
      </ul>
      <div class="apply-btn d-none d-sm-block">
        <a
          href="javascript:void(0)"
          @click="Apply(orderType)"
          class="btn btn-solid"
          >{{ _T('Apply') }}</a
        >
      </div>
      <div class="content-footer d-block d-sm-none">
        <a
          href="javascript:void(0)"
          class="btn btn-outline"
          @click="closeDineTypes()"
          >{{ _T('Back') }}</a
        >
        <a
          href="javascript:void(0)"
          class="btn btn-solid ml-15"
          @click="Apply(orderType)"
          >{{ _T('Apply') }}</a
        >
      </div>
    </div>
    <div class="mobile-overlay" :class="{ show: openDineDropdown }"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: '',
  data() {
    return {
      openDineDropdown: false,
      orderType: 'CRM',
      orderActive: 'Delivery',
    }
  },
  computed: {
    ...mapGetters(['availableModules', '_T']),
  },
  methods: {
    openDineTypes() {
      this.openDineDropdown = !this.openDineDropdown
    },
    closeDineTypes() {
      this.openDineDropdown = false
    },
    Apply(data) {
      this.$store.commit('SET_SELECTED_DELIVERY_OPTION', data)
      this.openDineDropdown = false
    },
  },
}
</script>
